import { LitElement, html } from 'lit';

class Loader extends LitElement {
	static get properties() {
		return {
			isLoading: { type: Boolean },
		};
	}

	constructor() {
		super();

		this.isLoading = false;
	}

	render() {
		return html`<div class="loader ${this.isLoading ? 'is-active' : ''}"></div>`;
	}

	createRenderRoot() {
		return this;
	}
}

customElements.define('x-loader', Loader);

export default Loader;

